<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize
    }"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
    :header-cell-style="headerCellStyle"
  >
    <!-- <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template> -->
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      type: Object,
      default: () => {}
    },
    loading: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox'
        },
        {
          title: this. $l('INDEX.goods_label_orderGoodsNo') || '订单产品编号',
          field: 'orderGoodsNo',
          headerAlign: 'center',
          align: 'center',
          width: 150,
          showHeaderOverflow: true,
          showOverflow: true
        },
        {
          title: this. $l('INDEX.goods_label_identifyGoodsNo') || '识别编号',
          field: 'identifyGoodsNo',
          headerAlign: 'center',
          align: 'left',
          width: 230,
          showHeaderOverflow: true,
          showOverflow: true
        },
        {
          title: this. $l('INDEX.goods_label_orderGoodsName') || '订单产品名称',
          field: 'orderGoodsDisplayName',
          headerAlign: 'center',
          align: 'left',
          width: 380,
          showHeaderOverflow: true,
          showOverflow: true
        },
        {
          title: this. $l('INDEX.goods_label_qty') || '数量',
          field: 'qty',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true
        },
        {
          title: this. $l('INDEX.goods_label_inPackageQty') || '装箱入数',
          field: 'inPackageQty',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true
        },
        {
          title: this. $l('INDEX.goods_label_boxQty') || '箱数',
          field: 'boxQty',
          headerAlign: 'center',
          align: 'center',
          width: 120,
          showHeaderOverflow: true,
          showOverflow: true
        },
        // {
        //   title: this. $l('INDEX.goods_label_packageDesc') || '外包装说明',
        //   field: 'packageDesc',
        //   headerAlign: 'center',
        //   align: 'left',
        //   minWidth: 200,
        //   showHeaderOverflow: true,
        //   showOverflow: true
        // }
        // {
        //   title: this. $l('INDEX.goods_label_orderGoodsColor') || '产品颜色',
        //   field: 'orderGoodsColor',
        //   headerAlign: 'center',
        //   align: 'center',
        //   minWidth: 150,
        //   showHeaderOverflow: true,
        //   showOverflow: true,
        // },
        // {
        //   title: this. $l('INDEX.goods_label_isGroup') || '是否套装产品',
        //   field: 'isGroup',
        //   headerAlign: 'center',
        //   align: 'center',
        //   minWidth: 100,
        //   showHeaderOverflow: true,
        //   showOverflow: true,
        // },

        // {
        //   title: this. $l('INDEX.INDEX.table_label_modified_by') || '修改人姓名',
        //   field: 'modifyByName',
        //   headerAlign: 'center',
        //   align: 'center',
        //   minWidth: 120,
        //   showHeaderOverflow: true,
        //   showOverflow: true,
        // },
        // {
        //   title: this. $l('INDEX.INDEX.table_label_modification_date') || '修改时间',
        //   field: 'modifyTime',
        //   headerAlign: 'center',
        //   align: 'center',
        //   minWidth: 170,
        //   showHeaderOverflow: true,
        //   showOverflow: true,
        // },
      ]
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff'
        }
      }
    },
    //单行删除
    del(code) {
      this.$emit('batchDel', [code])
    },
    //批量删除前的验证
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this. $l('INDEX.INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning'
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this. $l('INDEX.INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning'
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.orderBatchGoodsCode
        })
      }
      return data
    }
  }
}
</script>
